<template>
  <a-drawer width="60%" :label-col="4" :wrapper-col="20" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-spin :spinning="loading">
      <a-descriptions :column="2" bordered v-if="form.id">
        <a-descriptions-item label="用户昵称" :span="1">
          {{ form.nickname || '-' }}
        </a-descriptions-item>
        <a-descriptions-item label="手机号" :span="1">
          {{ form.mobile || '-' }}
        </a-descriptions-item>
        <a-descriptions-item label="时间节点" :span="1">
          <span v-if="form.timeNode === 1">入院至术前</span>
          <span v-else-if="form.timeNode === 2">术后至出院前</span>
          <span v-else-if="form.timeNode === 3">出院时</span>
          <span v-else-if="form.timeNode === 4">出院后</span>
          <span v-else>-</span>
        </a-descriptions-item>
        <a-descriptions-item label="记录日期" :span="1">
          {{ form.recordDate || '-' }}
        </a-descriptions-item>
        <a-descriptions-item label="创建时间" :span="2">
          {{ parseTime(form.createTime) }}
        </a-descriptions-item>
        <a-descriptions-item label="相关图片" :span="2" v-if="pictureUrlList && pictureUrlList.length > 0">
          <div style="display: flex; flex-wrap: wrap; gap: 10px;">
            <img
              v-for="(url, index) in pictureUrlList"
              :key="index"
              :src="url"
              style="width: 100px; height: 100px; object-fit: cover; cursor: pointer;"
              @click="previewImage(url, pictureUrlList)"
              alt="相关图片"
            />
          </div>
        </a-descriptions-item>
        <a-descriptions-item label="诊断思考图片" :span="2" v-if="diagnosePictureUrlList && diagnosePictureUrlList.length > 0">
          <div style="display: flex; flex-wrap: wrap; gap: 10px;">
            <img
              v-for="(url, index) in diagnosePictureUrlList"
              :key="index"
              :src="url"
              style="width: 100px; height: 100px; object-fit: cover; cursor: pointer;"
              @click="previewImage(url, diagnosePictureUrlList)"
              alt="诊断思考图片"
            />
          </div>
        </a-descriptions-item>
        <a-descriptions-item label="诊断思考结果" :span="2" v-if="form.diagnoseResult">
          {{ form.diagnoseResult }}
        </a-descriptions-item>
      </a-descriptions>

      <!-- 标签 -->
      <a-divider orientation="left" style="margin-top: 20px;">
        <b>标签</b>
      </a-divider>
      <a-table
        v-if="form.tags && form.tags.length > 0"
        :columns="tagColumns"
        :data-source="form.tags"
        :pagination="false"
        size="small"
        bordered
      >
        <template slot="tagName" slot-scope="text, record">
          <span v-if="record.oneTagName || record.twoTagName || record.threeTagName">
            {{ record.oneTagName || '' }}{{ record.twoTagName ? ' / ' + record.twoTagName : '' }}{{ record.threeTagName ? ' / ' + record.threeTagName : '' }}
          </span>
          <span v-else-if="record.otherContent || record.otherImgUrls">其他</span>
          <span v-else>-</span>
        </template>
        <template slot="forecastTagName" slot-scope="text, record">
          {{ record.tagName || '-' }}
        </template>
        <template slot="otherInfo" slot-scope="text, record">
          <div v-if="record.otherImgUrls" style="margin-bottom: 10px;">
            <img
              v-for="(url, index) in getOtherImageUrls(record.otherImgUrls)"
              :key="index"
              :src="url"
              style="width: 80px; height: 80px; object-fit: cover; cursor: pointer; margin-right: 10px;"
              @click="previewImage(url, getOtherImageUrls(record.otherImgUrls))"
              alt="其他图片"
            />
          </div>
          <div v-if="record.otherContent">{{ record.otherContent }}</div>
          <span v-if="!record.otherImgUrls && !record.otherContent">-</span>
        </template>
      </a-table>
      <a-empty v-else description="暂无标签" />

      <!-- 预测 -->
      <a-divider orientation="left" style="margin-top: 20px;">
        <b>预测</b>
      </a-divider>
      <a-table
        v-if="form.forecasts && form.forecasts.length > 0"
        :columns="forecastColumns"
        :data-source="form.forecasts"
        :pagination="false"
        size="small"
        bordered
      >
      </a-table>
      <a-empty v-else description="暂无预测数据" />

      <!-- 干预 -->
      <a-divider orientation="left" style="margin-top: 20px;">
        <b>干预</b>
      </a-divider>
      <a-table
        v-if="form.intervenes && form.intervenes.length > 0"
        :columns="interveneColumns"
        :data-source="form.intervenes"
        :pagination="false"
        size="small"
        bordered
      >
        <template slot="interveneName" slot-scope="text, record">
          <span v-if="record.oneInterveneName || record.twoInterveneName || record.threeInterveneName">
            {{ record.oneInterveneName || '' }}{{ record.twoInterveneName ? ' / ' + record.twoInterveneName : '' }}{{ record.threeInterveneName ? ' / ' + record.threeInterveneName : '' }}
          </span>
          <span v-else>-</span>
        </template>
      </a-table>
      <a-empty v-else description="暂无干预数据" />
    </a-spin>
    <div class="bottom-control" style="margin-top: 20px;">
      <a-space>
        <a-button type="dashed" @click="cancel">
          关闭
        </a-button>
      </a-space>
    </div>
  </a-drawer>
</template>

<script>
import { getUserRecord } from '@/api/biz/userRecord'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      loading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        nickname: null,
        mobile: null,
        timeNode: null,
        recordDate: null,
        pictureUrls: null,
        diagnosePictureUrls: null,
        diagnoseResult: null,
        tags: [],
        forecasts: [],
        intervenes: [],
        createTime: null
      },
      open: false,
      tagColumns: [
        {
          title: '标签名称',
          dataIndex: 'tagName',
          scopedSlots: { customRender: 'tagName' },
          align: 'center'
        },
        {
          title: '其他信息',
          dataIndex: 'otherInfo',
          scopedSlots: { customRender: 'otherInfo' },
          align: 'center'
        }
      ],
      forecastColumns: [
        {
          title: '标签名称',
          dataIndex: 'tagName',
          scopedSlots: { customRender: 'forecastTagName' },
          align: 'center'
        },
        {
          title: '评分',
          dataIndex: 'score',
          align: 'center'
        },
        {
          title: '促进因素',
          dataIndex: 'stimulative',
          align: 'center'
        },
        {
          title: '阻碍因素',
          dataIndex: 'obstacleFactors',
          align: 'center'
        }
      ],
      interveneColumns: [
        {
          title: '干预标签',
          dataIndex: 'interveneName',
          scopedSlots: { customRender: 'interveneName' },
          align: 'center'
        },
        {
          title: '干预结果',
          dataIndex: 'interveneResult',
          align: 'center'
        }
      ]
    }
  },
  computed: {
    ossHost () {
      return process.env.VUE_APP_OSS_HOST || ''
    },
    pictureUrlList () {
      if (!this.form.pictureUrls) return []
      const urls = this.form.pictureUrls.split(',').filter(url => url && url.trim())
      return urls.map(url => {
        const trimmedUrl = url.trim()
        // 如果是相对路径（不以http://或https://开头），添加OSS主机前缀
        if (trimmedUrl && !trimmedUrl.startsWith('http://') && !trimmedUrl.startsWith('https://')) {
          return this.ossHost + trimmedUrl
        }
        return trimmedUrl
      })
    },
    diagnosePictureUrlList () {
      if (!this.form.diagnosePictureUrls) return []
      const urls = this.form.diagnosePictureUrls.split(',').filter(url => url && url.trim())
      return urls.map(url => {
        const trimmedUrl = url.trim()
        // 如果是相对路径（不以http://或https://开头），添加OSS主机前缀
        if (trimmedUrl && !trimmedUrl.startsWith('http://') && !trimmedUrl.startsWith('https://')) {
          return this.ossHost + trimmedUrl
        }
        return trimmedUrl
      })
    }
  },
  methods: {
    previewImage (currentUrl, urlList) {
      // 打开新窗口预览图片
      window.open(currentUrl, '_blank')
    },
    getOtherImageUrls (otherImgUrls) {
      if (!otherImgUrls) return []
      const ossHost = process.env.VUE_APP_OSS_HOST || ''
      return otherImgUrls.split(',').filter(url => url.trim()).map(url => {
        const trimmedUrl = url.trim()
        // 如果是相对路径（不以http://或https://开头），添加OSS主机前缀
        if (trimmedUrl && !trimmedUrl.startsWith('http://') && !trimmedUrl.startsWith('https://')) {
          return ossHost + trimmedUrl
        }
        return trimmedUrl
      })
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.form = {
        id: null,
        nickname: null,
        mobile: null,
        timeNode: null,
        recordDate: null,
        pictureUrls: null,
        diagnosePictureUrls: null,
        diagnoseResult: null,
        tags: [],
        forecasts: [],
        intervenes: [],
        createTime: null
      }
    },
    /** 查看详情按钮操作 */
    handleQuery (record) {
      this.reset()
      this.open = true
      this.formTitle = '查看详情'
      this.loading = true
      getUserRecord({ id: record.id }).then(response => {
        this.form = response.data || {}
        // 确保数组字段存在
        if (!this.form.tags) this.form.tags = []
        if (!this.form.forecasts) this.form.forecasts = []
        if (!this.form.intervenes) this.form.intervenes = []
        this.loading = false
      }).catch(() => {
        this.loading = false
        this.$message.error('获取详情失败')
      })
    }
  }
}
</script>

<style scoped>
.bottom-control {
  text-align: right;
  padding-top: 20px;
}
</style>
